import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { Toaster } from "./components/ui/toaster";
import MainLayoutNew from "./components/Layout/MainLayoutNew";
import Login from "./pages/Login";
import Panel from "./pages/Panel";
import ExpedientesContainer from "./pages/ExpedientesContainer";
import ExpedienteDetalle from "./pages/ExpedienteDetalle";
import ContactosNew from "./pages/ContactosNew";
import ContactoDetalle from "./pages/ContactoDetalle";
import Plantillas from "./pages/Plantillas";
import Informes from "./pages/Informes";
import Comunicaciones from "./pages/Comunicaciones";
import Facturas from "./pages/Facturas";
import Agenda from "./pages/Agenda";
import Calculadora from "./pages/Calculadora";
import Configuracion from "./pages/Configuracion";
import Chat from "./pages/Chat";
import FilePreview from "./components/FilePreview";
import ConfiguracionEmail from "./pages/ConfiguracionEmail";
import CategoriasCalendario from "./pages/CategoriasCalendario";
import Contabilidad from "./pages/Contabilidad";
import FacturaDetalle from "./pages/FacturaDetalle";
import ControlesGastos from "./pages/ControlesGastos";
import EstadisticasGastos from "./pages/EstadisticasGastos";
import Morosidad from "./pages/Morosidad";
import EstadisticasMorosidad from "./pages/EstadisticasMorosidad";
import TareasDespacho from "./pages/TareasDespacho";
import EstadisticasTareas from "./pages/EstadisticasTareas";
import EstadisticasExpedientes from "./pages/EstadisticasExpedientes";
import EstadisticasPagoTasas from "./pages/EstadisticasPagoTasas";
import AnalisisHipotecas from "./pages/AnalisisHipotecas";
import AnalisisHipotecaDetalle from "./pages/AnalisisHipotecaDetalle";
import AnalisisHipotecasConfig from "./pages/AnalisisHipotecasConfig";
import AnalisisCAHipotecaria from "./pages/AnalisisCAHipotecaria";
import AnalisisCADetalle from "./pages/AnalisisCADetalle";
import ConfiguracionPromptsIA from "./pages/ConfiguracionPromptsIA";
import EstadisticasContactos from "./pages/EstadisticasContactos";
import ConfiguracionLogo from "./pages/ConfiguracionLogo";
import ConfiguracionCuentasEmail from "./pages/ConfiguracionCuentasEmail";
import ReclamacionExtrajudicial from "./pages/ReclamacionExtrajudicial";
import ReclamacionDetalle from "./pages/ReclamacionDetalle";
import EstafasBancarias from "./pages/EstafasBancarias";
import EstafaBancariaDetalle from "./pages/EstafaBancariaDetalle";
import ConfiguracionCatalogoClausulas from "./pages/ConfiguracionCatalogoClausulas";
import ConfiguracionAtencionCliente from "./pages/ConfiguracionAtencionCliente";
import ConfiguracionDiagnostico from "./pages/ConfiguracionDiagnostico";
import ConfiguracionModulosMenu from "./pages/ConfiguracionModulosMenu";
import ConfiguracionBackups from "./pages/ConfiguracionBackups";
import ConfiguracionEmpresa from "./pages/ConfiguracionEmpresa";
import ImportacionDatos from "./pages/ImportacionDatos";
import ActualizarSistema from "./pages/ActualizarSistema";
import GestionDatos from "./pages/GestionDatos";
import Correo from "./pages/Correo";
import PortalCliente from "./pages/PortalCliente";
import Colaboracion from "./pages/Colaboracion";
import AuditoriaRGPD from "./pages/AuditoriaRGPD";
import PrivacidadRGPD from "./pages/PrivacidadRGPD";
import S3Management from "./pages/S3Management";
import DocumentosAuto from "./pages/DocumentosAuto";
import Sentencias from "./pages/Sentencias";
import ConfiguracionPortalCliente from "./pages/ConfiguracionPortalCliente";
import ConfiguracionCuentasCorreo from "./pages/ConfiguracionCuentasCorreo";
import Actuaciones from "./pages/Actuaciones";
import RRHH from "./pages/RRHH";
import ConfiguracionPlantillasEstafas from "./pages/ConfiguracionPlantillasEstafas";
import ConfiguracionPlantillasCobrettis from "./pages/ConfiguracionPlantillasCobrettis";
import ConfiguracionPlantillasExtrajudicial from "./pages/ConfiguracionPlantillasExtrajudicial";
import AuditoriaExpedientes from "./pages/AuditoriaExpedientes";
import AuditoriasProcesales from "./pages/AuditoriasProcesales";
import AuditoriaIAPanel from "./pages/AuditoriaIAPanel";  // __V105__
import Intereses from "./pages/Intereses";
import Cobrettis from "./pages/Cobrettis";
import CobrettiDetalle from "./pages/CobrettiDetalle";
import Automatizacion from "./pages/Automatizacion";
import InformePublicoHipoteca from "./pages/InformePublicoHipoteca";
import ConfiguracionApiKeys from "./pages/ConfiguracionApiKeys";  // __V74__
import ConfiguracionPlantillasWord from "./pages/ConfiguracionPlantillasWord";  // __V72B__
import Ejecuciones from './pages/Ejecuciones';
import EjecucionDetalle from './pages/EjecucionDetalle';
import ConfiguracionConsumoIA from "./components/ConfiguracionConsumoIA";
import FirmarDocumento from "./pages/FirmarDocumento";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/panel" element={<MainLayoutNew><Panel /></MainLayoutNew>} />
          <Route path="/calendario" element={<MainLayoutNew><Agenda /></MainLayoutNew>} />
          <Route path="/calculadora" element={<MainLayoutNew><Calculadora /></MainLayoutNew>} />
          <Route path="/contactos" element={<MainLayoutNew><ContactosNew /></MainLayoutNew>} />
          <Route path="/contactos/estadisticas" element={<MainLayoutNew><EstadisticasContactos /></MainLayoutNew>} />
          <Route path="/contactos/:id" element={<MainLayoutNew><ContactoDetalle /></MainLayoutNew>} />
          <Route path="/expedientes" element={<MainLayoutNew><ExpedientesContainer /></MainLayoutNew>} />
          <Route path="/expedientes/estadisticas" element={<MainLayoutNew><EstadisticasExpedientes /></MainLayoutNew>} />
          <Route path="/expedientes/auditorias" element={<MainLayoutNew><AuditoriasProcesales /></MainLayoutNew>} />
          <Route path="/expedientes/analisis-hipotecas" element={<MainLayoutNew><AnalisisHipotecas /></MainLayoutNew>} />
          <Route path="/expedientes/analisis-hipotecas/configuracion" element={<MainLayoutNew><AnalisisHipotecasConfig /></MainLayoutNew>} />
          <Route path="/expedientes/analisis-hipotecas/:id" element={<MainLayoutNew><AnalisisHipotecaDetalle /></MainLayoutNew>} />
          <Route path="/expedientes/analisis-ca-hipotecaria" element={<MainLayoutNew><AnalisisCAHipotecaria /></MainLayoutNew>} />
          <Route path="/expedientes/analisis-ca-hipotecaria/:id" element={<MainLayoutNew><AnalisisCADetalle /></MainLayoutNew>} />
          <Route path="/configuracion/prompts-ia" element={<MainLayoutNew><ConfiguracionPromptsIA /></MainLayoutNew>} />
          <Route path="/expedientes/pago-tasas" element={<MainLayoutNew><EstadisticasPagoTasas /></MainLayoutNew>} />
          <Route path="/expedientes/auditoria-ia" element={<MainLayoutNew><AuditoriaIAPanel /></MainLayoutNew>} />  {/* __V105__ */}
          <Route path="/expedientes/:id" element={<MainLayoutNew><ExpedienteDetalle /></MainLayoutNew>} />
          <Route path="/actuaciones" element={<MainLayoutNew><Actuaciones /></MainLayoutNew>} />
          <Route path="/informes" element={<MainLayoutNew><Informes /></MainLayoutNew>} />
          <Route path="/contabilidad" element={<MainLayoutNew><Contabilidad /></MainLayoutNew>} />
          <Route path="/contabilidad/factura/:id" element={<MainLayoutNew><FacturaDetalle /></MainLayoutNew>} />
          <Route path="/contabilidad/gastos" element={<MainLayoutNew><ControlesGastos /></MainLayoutNew>} />
          <Route path="/contabilidad/gastos/estadisticas" element={<MainLayoutNew><EstadisticasGastos /></MainLayoutNew>} />
          <Route path="/contabilidad/morosidad" element={<MainLayoutNew><Morosidad /></MainLayoutNew>} />
          <Route path="/contabilidad/morosidad/estadisticas" element={<MainLayoutNew><EstadisticasMorosidad /></MainLayoutNew>} />
          <Route path="/tareas" element={<MainLayoutNew><TareasDespacho /></MainLayoutNew>} />
          <Route path="/tareas/estadisticas" element={<MainLayoutNew><EstadisticasTareas /></MainLayoutNew>} />
          <Route path="/intereses" element={<MainLayoutNew><Intereses /></MainLayoutNew>} />
          <Route path="/rrhh" element={<MainLayoutNew><RRHH /></MainLayoutNew>} />
          <Route path="/extrajudicial" element={<MainLayoutNew><ReclamacionExtrajudicial /></MainLayoutNew>} />
          <Route path="/extrajudicial/:id" element={<MainLayoutNew><ReclamacionDetalle /></MainLayoutNew>} />
          <Route path="/estafas-bancarias" element={<MainLayoutNew><EstafasBancarias /></MainLayoutNew>} />
          <Route path="/estafas-bancarias/:id" element={<MainLayoutNew><EstafaBancariaDetalle /></MainLayoutNew>} />
          <Route path="/configuracion/logo" element={<MainLayoutNew><ConfiguracionLogo /></MainLayoutNew>} />
          <Route path="/configuracion/consumo-ia" element={<MainLayoutNew><ConfiguracionConsumoIA /></MainLayoutNew>} />
          <Route path="/configuracion/cuentas-email" element={<MainLayoutNew><ConfiguracionCuentasEmail /></MainLayoutNew>} />
          <Route path="/configuracion/catalogo-clausulas" element={<MainLayoutNew><ConfiguracionCatalogoClausulas /></MainLayoutNew>} />
          <Route path="/configuracion/atencion-cliente" element={<MainLayoutNew><ConfiguracionAtencionCliente /></MainLayoutNew>} />
          <Route path="/configuracion/diagnostico" element={<MainLayoutNew><ConfiguracionDiagnostico /></MainLayoutNew>} />
          <Route path="/configuracion/modulos-menu" element={<MainLayoutNew><ConfiguracionModulosMenu /></MainLayoutNew>} />
          <Route path="/configuracion/backups" element={<MainLayoutNew><ConfiguracionBackups /></MainLayoutNew>} />
          <Route path="/configuracion/empresa" element={<MainLayoutNew><ConfiguracionEmpresa /></MainLayoutNew>} />
          <Route path="/configuracion/importacion" element={<MainLayoutNew><ImportacionDatos /></MainLayoutNew>} />
          <Route path="/configuracion/actualizaciones" element={<MainLayoutNew><ActualizarSistema /></MainLayoutNew>} />
          <Route path="/configuracion/gestion-datos" element={<MainLayoutNew><GestionDatos /></MainLayoutNew>} />
          <Route path="/configuracion/auditoria" element={<MainLayoutNew><AuditoriaRGPD /></MainLayoutNew>} />
          <Route path="/configuracion/privacidad-rgpd" element={<MainLayoutNew><PrivacidadRGPD /></MainLayoutNew>} />
          <Route path="/configuracion/s3" element={<MainLayoutNew><S3Management /></MainLayoutNew>} />
          <Route path="/configuracion/portal-cliente" element={<MainLayoutNew><ConfiguracionPortalCliente /></MainLayoutNew>} />
          <Route path="/configuracion/cuentas-correo" element={<MainLayoutNew><ConfiguracionCuentasCorreo /></MainLayoutNew>} />
          <Route path="/configuracion/plantillas-estafas" element={<MainLayoutNew><ConfiguracionPlantillasEstafas /></MainLayoutNew>} />
          <Route path="/configuracion/plantillas-cobrettis" element={<MainLayoutNew><ConfiguracionPlantillasCobrettis /></MainLayoutNew>} />
          <Route path="/configuracion/plantillas-extrajudicial" element={<MainLayoutNew><ConfiguracionPlantillasExtrajudicial /></MainLayoutNew>} />
          <Route path="/configuracion/api-keys" element={<MainLayoutNew><ConfiguracionApiKeys /></MainLayoutNew>} />  {/* __V74__ */}
          <Route path="/configuracion/plantillas-word" element={<MainLayoutNew><ConfiguracionPlantillasWord /></MainLayoutNew>} />  {/* __V72B__ */}
          <Route path="/colaboracion" element={<MainLayoutNew><Colaboracion /></MainLayoutNew>} />
          <Route path="/documentos-auto" element={<MainLayoutNew><DocumentosAuto /></MainLayoutNew>} />
          <Route path="/sentencias" element={<MainLayoutNew><Sentencias /></MainLayoutNew>} />
          <Route path="/auditoria-expedientes" element={<MainLayoutNew><AuditoriaExpedientes /></MainLayoutNew>} />
          <Route path="/cobrettis" element={<MainLayoutNew><Cobrettis /></MainLayoutNew>} />
          <Route path="/cobrettis/:id" element={<MainLayoutNew><CobrettiDetalle /></MainLayoutNew>} />
          <Route path="/automatizacion" element={<MainLayoutNew><Automatizacion /></MainLayoutNew>} />
          <Route path="/portal-cliente" element={<PortalCliente />} />
          <Route path="/comunicaciones" element={<MainLayoutNew><Comunicaciones /></MainLayoutNew>} />
          <Route path="/lexnet" element={<MainLayoutNew><div className="p-6"><h1 className="text-2xl font-bold">Lexnet</h1><p className="text-gray-600 mt-2">Módulo en desarrollo</p></div></MainLayoutNew>} />
          <Route path="/correo" element={<MainLayoutNew><Correo /></MainLayoutNew>} />
          <Route path="/plantillas" element={<MainLayoutNew><Plantillas /></MainLayoutNew>} />
          <Route path="/configuracion" element={<MainLayoutNew><Configuracion /></MainLayoutNew>} />
          <Route path="/configuracion/email" element={<MainLayoutNew><ConfiguracionEmail /></MainLayoutNew>} />
          <Route path="/configuracion/categorias-calendario" element={<MainLayoutNew><CategoriasCalendario /></MainLayoutNew>} />
          <Route path="/chat" element={<MainLayoutNew><Chat /></MainLayoutNew>} />
          <Route path="/preview/:adjuntoId" element={<FilePreview />} />
          <Route path="/informe-publico/:token" element={<InformePublicoHipoteca />} />
          <Route path="/firmar/:token" element={<FirmarDocumento />} />
          <Route path="/" element={<Navigate to="/panel" replace />} />
                  <Route path="/ejecuciones" element={<Ejecuciones />} />
          <Route path="/ejecuciones/:id" element={<EjecucionDetalle />} />
        </Routes>
        <Toaster />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;